import { Component, OnInit, Renderer2 } from '@angular/core';
import { AppAssets } from './app.assests';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { defaultTenantKey, tenantSettings, ThemeModule, ThemeService } from 'src/theme';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [CommonModule, RouterModule, ThemeModule],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
    constructor(appAssets: AppAssets, private readonly themeService: ThemeService, private renderer: Renderer2) {}

    ngOnInit() {
        const tenantKey = localStorage.getItem('tenantKey') || '';
        this.setTheme(tenantKey);
        this.setFavicon(this.themeService.getActiveThemeAssets('favicon') as string);
    }

    private setTheme(tenantKey: string) {
        const selectedTenant = tenantSettings.find((tenant) => tenant.key === tenantKey) || defaultTenantKey;

        if (selectedTenant) {
            this.themeService.setTheme(selectedTenant.theme);
        }
        if (!tenantKey  || tenantKey == 'tenant12_api') {
            document.body.style.backgroundImage = 'none';
            document.body.style.background = '#F6F8FF';
        }else{
            document.body.style.backgroundImage = 'url("./assets/Background.png")';
        }
    }

    setFavicon(url: string): void {
        const head = document.head;
        const existingFavicon = document.querySelector("link[rel='icon']");

        if (existingFavicon) {
            this.renderer.setAttribute(existingFavicon, 'href', url);
        } else {
            const newFavicon = this.renderer.createElement('link');
            this.renderer.setAttribute(newFavicon, 'rel', 'icon');
            this.renderer.setAttribute(newFavicon, 'href', url);
            this.renderer.appendChild(head, newFavicon);
        }
    }
}
